import * as moment from 'moment';

export const unixAdapter = (timestamp) => {
	return moment.unix(timestamp).format('DD/MM/YY, HH:mm A');
};
